// payment error codes

module.exports = {
  '00': 'Transaction approuvée ou traitée avec succès',
  '02': 'Contacter l’émetteur de carte',
  '03': 'Accepteur invalide',
  '04': 'Conserver la carte',
  '05': 'Ne pas honorer',
  '07': 'Conserver la carte, conditions spéciales',
  '08': 'Approuver après identification',
  '12': 'Transaction invalide',
  '13': 'Montant invalide',
  '14': 'Numéro de porteur invalide',
  '15': 'Emetteur de carte inconnu',
  '17': 'Annulation acheteur',
  '19': 'Répéter la transaction ultérieurement',
  '20': 'Réponse erronée (erreur dans le domaine serveur)',
  '24': 'Mise à jour de fichier non supportée',
  '25': 'Impossible de localiser l’enregistrement dans le fichier',
  '26': 'Enregistrement dupliqué, ancien enregistrement remplacé',
  '27': 'Erreur en « edit » sur champ de liste à jour fichier',
  '28': 'Accès interdit au fichier',
  '29': 'Mise à jour impossible',
  '30': 'Erreur de format',
  '31': 'Identifiant de l’organisme acquéreur inconnu',
  '33': 'Date de validité de la carte dépassée',
  '34': 'Suspicion de fraude',
  '38': 'Date de validité de la carte dépassée',
  '41': 'Carte perdue',
  '43': 'Carte volée',
  '51': 'Provision insuffisante ou crédit dépassé',
  '54': 'Date de validité de la carte dépassée',
  '55': 'Code confidentiel erroné',
  '56': 'Carte absente du fichier',
  '57': 'Transaction non permise à ce porteur',
  '58': 'Transaction non permise à ce porteur',
  '59': 'Suspicion de fraude',
  '60': 'L’accepteur de carte doit contacter l’acquéreur',
  '61': 'Montant de retrait hors limite',
  '63': 'Règles de sécurité non respectées',
  '68': 'Réponse non parvenue ou reçue trop tard',
  '75': 'Nombre d’essais code confidentiel dépassé',
  '76': 'Porteur déjà en opposition, ancien enregistrement conservé',
  '90': 'Arrêt momentané du système',
  '91': 'Émetteur de cartes inaccessible',
  '94': 'Transaction dupliquée',
  '96': 'Mauvais fonctionnement du système',
  '97': 'Échéance de la temporisation de surveillance globale',
  '98': 'Serveur indisponible routage réseau demandé à nouveau',
  '99': 'Incident domaine initiateur'
};
